module.exports = __webpack_public_path__ + "img/9.2626de6c.png";